import { clientActions } from '../config/actions';

const defaultState = {
  isLoading: false,
  data: [],
  created: false,
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case clientActions.CLIENTS_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || false,
        created: state.created,
        error: null
      };
    case clientActions.CLIENTS_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        created: false,
        error: action.error
      };
    case clientActions.CLIENTS_NEW:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: true,
        error: null
      };
    case clientActions.CLIENTS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        created: false,
        error: null
      };
    case clientActions.CLIENTS_RESET:
      return {
        ...state,
        isLoading: false,
        data: [],
        created: false,
        error: null
      };
    default:
      return state;
  }
};
